module.exports = __webpack_public_path__ + "img/1504932329.de916ecb.jpg";